// extracted by mini-css-extract-plugin
export default {"discountContainer":"Discounts_discountContainer__5jixP"};